import { isString } from 'lodash-es'

import { getReferenceDataClass } from './getDataClass'
import { getReferenceDataItemFromDataClass } from './getDataItem'
import { ReferenceFilter } from '@/Data/typesV2'
import { getDataItemTitle } from '@/utils/dataClassMap'

export const getReferenceDisplayValue = (
  id: unknown,
  referenceTo?: string,
  referenceFilter?: ReferenceFilter,
) => {
  if (!isString(id) || !referenceTo) return ''
  const dataClass = getReferenceDataClass(referenceTo, referenceFilter)
  if (!dataClass) return ''

  const reference = getReferenceDataItemFromDataClass(dataClass, id)
  const title = getDataItemTitle(reference?.dataItem)
  return title || ''
}
